import { render } from "./serviceArchieve.vue?vue&type=template&id=d304b210&scoped=true"
import script from "./serviceArchieve.vue?vue&type=script&lang=js"
export * from "./serviceArchieve.vue?vue&type=script&lang=js"

import "./serviceArchieve.vue?vue&type=style&index=0&id=d304b210&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d304b210"]])

export default __exports__